<template>
    <div class="internal">

        <header-view
            :titulo="titulo"
            :breadcrumbs="true"
            :categories="categories"
            :category="Contato">
        </header-view>

        <pulse-loader :loading="loading" class="text-center"></pulse-loader>

        <div class="container">

            <div class="row">

                <!-- Single Commerce -->
                <div class="single-commerce">
                    <div class="col-sm-offset-2 col-sm-8">

                        <h1 class="text-center">Entre em contato</h1>
                        <h2 class="text-center" style="margin:0"><small class="text-center" style="font-size: 14px;">Todos os campos são obrigatórios.</small></h2>

                        <div class="form-horizontal" style="margin: 30px 0;">

                            <p class="message text-center" v-if="messageResult">{{messageResult}}</p>

                            <fieldset>
                        
                                <div class="form-group">
                                <label class="col-md-3 control-label" for="name">Nome</label>
                                <div class="col-md-9">
                                    <input id="name" name="name" type="text" placeholder="" class="form-control" v-model="name" required>
                                </div>
                                </div>
                        
                                <div class="form-group">
                                <label class="col-md-3 control-label" for="email">E-mail</label>
                                <div class="col-md-9">
                                    <input id="email" name="email" type="text" placeholder="" class="form-control" v-model="email" required>
                                </div>
                                </div>
                        
                                <div class="form-group">
                                <label class="col-md-3 control-label" for="email">Telefone</label>
                                <div class="col-md-9">
                                    <input id="phone" name="phone" type="text" placeholder="" class="form-control" v-model="phone" required>
                                </div>
                                </div>

                                <div class="form-group">
                                <label class="col-md-3 control-label" for="message">Mensagem</label>
                                <div class="col-md-9">
                                    <textarea class="form-control" id="message" name="message" placeholder="" rows="5" v-model="message" required></textarea>
                                </div>
                                </div>
                        
                                <div class="form-group">
                                <div class="col-md-12 text-right">
                                    <button type="buttom" class="btn btn-primary btn-lg" :disabled="invalidForm" v-on:click="sendMail()">Enviar</button>
                                </div>
                                </div>
                            </fieldset>
                        </div>

                    </div>
                </div>
                <!-- End Single Commerce -->

            </div>
        </div>
        <!-- / End Empresas -->

        <footer-view></footer-view>
    </div>
</template>

<script>
import HeaderView from './layout/Header'
import FooterView from './layout/Footer'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import HTTP_Api from "../services/api.service";

export default {
  name: 'Contato',
  props: {
  },
  components: {
    HeaderView,
    FooterView,
    PulseLoader
  },
  data: function () {
    return {
      titulo: 'Contato',
      categories: [],
      clients: Object,
      category: '',
      loading: true,
      status: false,
      name: '',
      email: '',
      phone: '',
      message: '',
      messageResult: false
    }
  },
  methods: {
    getHome(pagenum) {
      this.loading = true;
      HTTP_Api.getHomeData(pagenum)
        .then(response => {
          this.status = response.data.status;
          this.clients = response.data.clients;
          this.categories = response.data.categories;
          this.meta = response.data.meta;
          this.loading = false;
          //console.log('this.clients',this.clients)
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
    sendMail: function() {

      this.messageResult =  '';
      this.loading = true;

      HTTP_Api.setName(this.name)
      HTTP_Api.setEmail(this.email)
      HTTP_Api.setPhone(this.phone)
      HTTP_Api.setMessage(this.message)

      HTTP_Api.sendMail()
        .then(response => {
          this.name = '';
          this.email = '';
          this.phone = '';
          this.message = '';
          this.messageResult = response.data.message;
          this.loading = false;
          console.log('response',response)
        })
        .catch(e => {
          this.errors.push(e);
        });
    }
  },
  created() {
    this.getHome();
  },
  computed: {
    user () {
      return {
        displayName: '',
        avatar: '',
        roles: ['', '']
      }
    },
    invalidForm () {
      if (this.name == '' || this.email == '' || this.phone == '' || this.message == '') {
        return true
      } else {
       return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contato.vue